export const NEW_TOTAL = { id: 'new', type: 0 };
export const PAST_TOTAL = { id: 'past', type: 0 };
export const BRONZE = { id: 'bronze', type: 1 };
export const SILVER = { id: 'silver', type: 2 };
export const GOLD = { id: 'gold', type: 3 };
export const PLATINUM = { id: 'platinum', type: 4 };
export const EMERALD = { id: 'emerald', type: 5 };
export const DIAMOND = { id: 'diamond', type: 6 };
export const EPIC = { id: 'epic', type: 7 };
export const LEGEND = { id: 'legend', type: 8 };



// WEBPACK FOOTER //
// ./containers/participation/config/certificate-constants.js